var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.$style.buttons },
    [
      _c("save-button", {
        on: { save: _vm.$rbEmit, setDefaultFilters: _vm.$rbEmit },
      }),
      _c(
        "button",
        {
          staticClass: "rbButton mainButton",
          on: {
            click: function ($event) {
              return _vm.$rbEmit({ name: "done" })
            },
          },
        },
        [
          _c("i", { staticClass: "material-icons" }, [_vm._v("check_circle")]),
          _c("span", [_vm._v("Done")]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }